import React from 'react'
import { TransitOperationFormValues } from 'features/declaration/models/schemas/transitOperationFormSchema'
import TransportDocuments from 'features/declaration/form/components/TransportDocuments'
import SupportingDocuments from 'features/declaration/form/components/SupportingDocuments'
import PreviousDocuments from 'features/declaration/form/components/PreviousDocuments'
import {
  blankPreviousDocument,
  blankSupportingDocument,
  blankTransportDocument,
} from 'features/declaration/models/blankItems'
import DeclarationTabLayout from 'features/declaration/form/components/DeclarationTabLayout'
import GeneralSection from 'features/declaration/form/components/general/GeneralSection'
import ActiveBorderTransportMeans from 'features/declaration/form/components/general/ActiveBorderTransportMeans'
import PlaceOfLoading from 'features/declaration/form/components/general/PlaceOfLoading'
import PlaceOfUnloading from 'features/declaration/form/components/general/PlaceOfUnloading'
import TransportSection from 'features/declaration/form/components/general/TransportSection'
import PlaceOfAcceptance from 'features/declaration/form/components/general/PlaceOfAcceptance'
import PlaceOfDelivery from 'features/declaration/form/components/general/PlaceOfDelivery'
import LocationOfGoods from 'features/declaration/form/components/general/LocationOfGoods'
import useDeclarationCountry from '../../components/useDeclarationCountry'

function EnsGeneralTab() {
  const country = useDeclarationCountry()

  return (
    <DeclarationTabLayout
      start={(
        <GeneralSection />
      )}
      centerLeft={(
        <>
          <TransportSection isEnsMode />
          <ActiveBorderTransportMeans />
        </>
      )}
      centerRight={(
        <>
          <PlaceOfLoading />
          <PlaceOfUnloading />
          <TransportDocuments<TransitOperationFormValues>
            scope="transitOperation"
            createDefault={() => blankTransportDocument}
            isEns
            country={country}
          />
          {
            country === 'RO'
            && (
              <PreviousDocuments<TransitOperationFormValues>
                scope="transitOperation"
                createDefault={() => blankPreviousDocument}
                country={country}
              />
            )
          }
          <SupportingDocuments<TransitOperationFormValues>
            scope="transitOperation"
            createDefault={() => blankSupportingDocument}
            isEns
            country={country}
          />
        </>
      )}
      end={(
        <>
          <PlaceOfAcceptance />
          <PlaceOfDelivery />
          <LocationOfGoods />
        </>
      )}
    />
  )
}

export default EnsGeneralTab
